/**
 * Call Store
 * Manages voice call state and audio streams
 */

import { create } from 'zustand';
import type { CallStatus, CallState } from '@/types';

interface CallStore extends CallState {
  // Actions
  setCallId: (callId: string | null) => void;
  setCallStatus: (status: CallStatus) => void;
  setIsCallActive: (isActive: boolean) => void;
  setAudioStream: (stream: MediaStream | null) => void;
  setError: (error: string | null) => void;
  startCall: (callId: string) => void;
  endCall: () => void;
  reset: () => void;
}

const initialState: CallState = {
  callId: null,
  callStatus: 'idle',
  isCallActive: false,
  audioStream: null,
  error: null,
};

/**
 * Call store hook
 */
export const useCallStore = create<CallStore>((set) => ({
  ...initialState,

  setCallId: (callId) =>
    set({ callId }),

  setCallStatus: (callStatus) =>
    set({ callStatus }),

  setIsCallActive: (isCallActive) =>
    set({ isCallActive }),

  setAudioStream: (audioStream) =>
    set({ audioStream }),

  setError: (error) =>
    set({ error, callStatus: error ? 'error' : 'idle' }),

  startCall: (callId) =>
    set({
      callId,
      callStatus: 'connecting',
      isCallActive: false,
      error: null,
    }),

  endCall: () =>
    set({
      callStatus: 'ended',
      isCallActive: false,
      audioStream: null,
    }),

  reset: () => set(initialState),
}));
